import { render, staticRenderFns } from "./AiChatService.vue?vue&type=template&id=6c3b89ee"
import script from "./AiChatService.vue?vue&type=script&lang=js"
export * from "./AiChatService.vue?vue&type=script&lang=js"
import style0 from "./AiChatService.vue?vue&type=style&index=0&id=6c3b89ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports